var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCopy = function SvgIconCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.25 2.75a1 1 0 0 0-1 1v3.5h-3.5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.5h3.5a1 1 0 0 0 1-1v-12a1 1 0 0 0-1-1zm8.5 12h2.5v-10h-10v2.5h6.5a1 1 0 0 1 1 1zm-12-5.5v10h10v-10z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCopy;